<template>
  <div id="combination" class="flex center">
    <div class="container">
      <div class="operational flex bCenter" v-if="config.showTitle"  :class="{'top-border':!config.tabs.showTabs}">
        <div class="operational-left">
          <P>{{ config.title }}</P>
        </div>
        <div class="operational-right flex middle">
          <div class="more flex middle" v-if="config.moreBtn.showMoreBtn">
            <el-link :underline="false" :href="config.moreBtn.linkUrl">更多<img :src="require('assets/images/online-learning/more.png')"></el-link>
          </div>
        </div>
      </div>
      <el-tabs type="card" v-if="config.tabs.showTabs" :class="{'border':borderColor}">
        <el-tab-pane
          v-for="(tab,index) in config.tabs.labels"
          :key="index"
          :label="tab.labelName">
          <list :dataList="dataList.slice(index*4,index*4+4)" :config="config"></list>
        </el-tab-pane>
      </el-tabs>
      <list v-else :dataList="dataList" :config="config"></list>
    </div>
  </div>
</template>

<script>
import list from '@/components/list/list';

export default {
  props:['config','dataList'],
  components:{
    list
  },
  data(){
    return{
      config:config,
    }
  },
  computed:{
    borderColor(){
      if(this.config.list == '#fff'){
        return true;
      }else{
        return false;
      }
    }
  },
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
@import './combination.less';
</style>


